import currencyFormatter from "./currencyFormatter";

const wholeDollarFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const formatPercent = (value) => `${Number(value)}%`;

export const formatWholeDollars = (value) => wholeDollarFormatter.format(value);

export const formatBracketAmount = (value) => currencyFormatter.format(value);

export const formatAppliesTo = (lowBracket, highBracket) =>
  highBracket === null || highBracket === undefined
    ? `${currencyFormatter.format(lowBracket)} and above`
    : `${currencyFormatter.format(lowBracket)} - ${currencyFormatter.format(highBracket - 0.01)}`;

export const parsePercent = (value) => {
  if (value === "" || value === null || value === undefined) {
    return null;
  }

  const number = Number(value);

  if (!Number.isFinite(number) || number < 0 || number > 100) {
    return null;
  }

  if (Math.abs(Math.round(number * 10) - number * 10) > 1e-9) {
    return null;
  }

  return number;
};
